module.exports = __webpack_public_path__ + "53fe06d8aa47b7c81cdcd07d06fbd04b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sounds/paars.mp3
// module id = 35
// module chunks = 0